import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StringService, _ } from "src/services";
import { Modals, ModalsAction, Packages, PackagesAction } from "src/store";
import { Modal } from "./modal";

export const GiftModal: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const modals: Modals = useSelector((state: any) => state.ModalsState);
    const packages: Packages = useSelector((state: any) => state.PackagesState);

    //#end region

    //#region state

    const [code, setCode] = useState("");

    //#end region

    //region methods

    const onClose = () => {
        dispatch(ModalsAction.hideGift());
    };

    const onSubmit = () => {
        if (packages.sendingGiftCode || !code?.trim()) return;
        dispatch(PackagesAction.sendGiftCode(StringService.normalize(code)));
    };

    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const code = e.target.value;
        setCode(code);
    };


    //#end region


    //#region helpers

    const renderFooter = () => {
        return (

            <div className="col-12">
                <button onClick={onSubmit}
                    disabled={packages.sendingGiftCode || !code?.trim()}
                    className={`focusable btn btn-primary btn-md btn-submit focusable text-rtl w-100${packages.sendingGiftCode ? " btn-loading" : ""}`}>
                    {_("save")}
                </button>
            </div>
        );
    };

    useEffect(() => {

        if (packages.giftCodeApplied) setCode("");

    }, [packages.giftCodeApplied]);

    useEffect(() => {

        setCode("");

    }, [modals.gift]);



    const renderBody = () => {
        return (
            <div className="page-profile--header-content w-100">
                <div className="w-100">
                    <div className="form-group">
                        <label>{_("giftCode")}</label>
                        <input
                            value={code}
                            onChange={onCodeChange}
                            placeholder={_("giftCodePlaceholder")}
                            className="form-control-transparent page-profile--full-name form-control text-rtl text-right focusable"
                            maxLength={30}
                            type="text"
                        />
                    </div>
                </div>
            </div>
        );
    };

    //#end region

    return (
        <Modal title={_("giftCodeTitle")} show={modals.gift} onClose={onClose} renderFooter={renderFooter} className="modal-component--profile">
            <div className="content text-right">
                {renderBody()}
            </div>
        </Modal>
    );

};